import React from 'react';

import { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

import { ApiGet, ApiPatch, ApiPost } from '../../helper/API/ApiData';
import { useForm, useFieldArray } from "react-hook-form"
import FormInput from '../../components/form/FormInput';
import { toast } from 'react-toastify';
import GroupMemberCreateTrainingForm from './GroupMemberTrainingCreateForm';

const AddUpdateGroupMemberTrainings = () => {

    const navigate = useNavigate()
    const { group_member_id } = useParams();

    const [fields, setFields] = useState({})
    const [trainings, setTrainings] = useState([])

    const groupMemberTrainingsId = new URLSearchParams(window.location.search).get("id")
    const isUpdateRequest = !!groupMemberTrainingsId

    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
        setValue,
        setError,
    } = useForm()


    const onSubmit = (data: any) => {
        console.log("🚀 ~ onSubmit ~ data 37:", data)
        if (isUpdateRequest) {
            ApiPatch(`group_member/${group_member_id}/trainings/${groupMemberTrainingsId}`, data)
                .then((res: any) => {
                    if (res.status === 200) {
                        toast.success("Successfully updated Member Training")
                        navigate(`?page=training`)
                    }
                }).catch((error) => {
                    if (error.status === 400 && error.code === 'validation_error') {
                        error.data.validation.body.keys
                        setError(error.data.validation.body.keys[0],
                            { type: "server", message: error.data.validation.body.message },
                            { shouldFocus: true })
                    }
                    return error
                })
        }
        else {
            ApiPost(`group_member/${group_member_id}/trainings/add`, data)
                .then((res: any) => {
                    if (res.status === 200) {
                        toast.success("Successfully added Member Training")
                        // Clear all fields
                        reset()
                        navigate(`?page=training`)

                        // navigate(`/shgadmin/group_member/${group_member_id}/?page=home`)
                    }
                }).catch((error) => {
                    if (error.status === 400 && error.code === 'validation_error') {
                        error.data.validation.body.keys
                        setError(error.data.validation.body.keys[0],
                            { type: "server", message: error.data.validation.body.message },
                            { shouldFocus: true })
                    }
                    return error
                })
        }
    }
    useEffect(() => {
        if (isUpdateRequest) {
            // Get groupMember object
            ApiGet(`group_member/${group_member_id}/trainings/${groupMemberTrainingsId}`)
                .then((res: any) => {
                    if (res?.status === 200) {
                        const groupMemberTrainingsData = res.data[0]
                        // Getting field names
                        ApiGet(`group_member/${group_member_id}/trainings/add`)
                            .then((res: any) => {
                                if (res?.status === 200) {
                                    setFields({
                                        training: {
                                            type: 'enum',
                                            validations: {
                                                enum: [{
                                                    id: groupMemberTrainingsData.shg_training.id,
                                                    name: `${groupMemberTrainingsData.shg_training.name_of_trainer} ${new Date(groupMemberTrainingsData.shg_training.start_timestamp).toLocaleString()} to ${new Date(groupMemberTrainingsData.shg_training.end_timestamp).toLocaleTimeString()}`
                                                }],
                                                required: true
                                            }
                                        },
                                        ...res.data
                                    })
                                }
                            })
                            .catch((error) => {
                                return error
                            })
                        // Setting field values
                        Object.keys(groupMemberTrainingsData).map((key) => {
                            if (key === 'shg_training') {
                                setValue('training', groupMemberTrainingsData[key].id, { shouldValidate: true, shouldTouch: true });
                            }
                            else {
                                setValue(key, groupMemberTrainingsData[key], { shouldValidate: true, shouldTouch: true });
                            }
                        })
                    }
                })
                .catch((error) => {
                    return error
                })
        }
        // Get trainings of the shg
        ApiGet(`group_member/${group_member_id}/trainings/shg_trainings`)
            .then((res: any) => {
                if (res?.status === 200) {
                    const shgTrainings = res.data.map((shgTraining: any) => {
                        return {
                            id: shgTraining.id,
                            name: `${shgTraining.name_of_trainer} ${new Date(shgTraining.start_timestamp).toLocaleString()} to ${new Date(shgTraining.end_timestamp).toLocaleTimeString()}`
                        }
                    })
                    setTrainings(shgTrainings)
                }
            })
            .catch((error) => {
                return error
            })

    }, [])

    return (
        <>
            {isUpdateRequest ?
                <>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='General_Info border-none'>
                            <Row>
                                {Object.entries(fields).map(([fieldName, fieldOptions]: [string, unknown | any], index) => {
                                    return (
                                        <Col key={index} xl={4} lg={4} md={6} className="mt-3">
                                            <FormInput name={fieldName} fieldOptions={fieldOptions} disabled={fieldName === 'training'}
                                                control={control} errors={errors} />
                                        </Col>
                                    )
                                })}
                            </Row>
                        </div>
                        <Row className='d-flex justify-content-center mt-3' >
                            <div className='d-flex justify-content-center'>
                                <button className='btn' style={{ backgroundColor: "#082979", color: "#fff" }} type="submit" name="submit">
                                    Update Training
                                </button>
                            </div>
                        </Row>
                    </form>
                </>
                :
                <GroupMemberCreateTrainingForm trainings={trainings} />
            }



        </>
    );
};

export default AddUpdateGroupMemberTrainings;

